/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/gatsby';
import { submitContactForm } from './actions';

interface ContactUsState {
  openContactForm: boolean;
  loading: boolean;
  successfullySubmittedForm: boolean;
  error: string | null;
  dealContext: ContactUsDealContext | null;
}

const initialState = {
  openContactForm: false,
  loading: false,
  successfullySubmittedForm: false,
  error: null,
  dealContext: null,
} as ContactUsState;

const contactUsSlice = createSlice({
  name: 'contactus',
  initialState,
  reducers: {
    toggleOpenContactForm(state, action) {
      state.loading = false;
      state.successfullySubmittedForm = false;
      state.error = null;
      state.openContactForm = action.payload;
    },
    setContactUsDealContext(state, action) {
      state.dealContext = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(submitContactForm.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(submitContactForm.fulfilled, (state) => {
      state.successfullySubmittedForm = true;
      state.error = null;
      state.loading = false;
    });
    builder.addCase(submitContactForm.rejected, (state, { payload, error }) => {
      const errorMessage =
        payload && typeof payload === 'object' && 'message' in payload
          ? (payload as { message: string }).message
          : 'Something went wrong while submitting your request. Please try again.';
      state.error = errorMessage;
      state.successfullySubmittedForm = false;
      state.loading = false;
      Sentry.captureException(error || payload);
    });
  },
});

export const { toggleOpenContactForm, setContactUsDealContext } =
  contactUsSlice.actions;

export default contactUsSlice.reducer;
